<ng-container *transloco="let convert;">
  <div class="edit-posting-form" *transloco="let convert;">
    <h3 class="content-card-title">{{convert('sellModule.posting.locationForm.textLocation')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.locationForm.textSelectOptionLocation')}}</div>
    <form class="body mt-2" name="locationForm" [formGroup]="locationForm" nonvalidate>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="control-wrapper mt-3">
            <div class="custom-control custom-radio custom-control-inline ">
              <input type="radio" id="storageLocationCheckBox" name="radioSelection" class="custom-control-input"
                formControlName="radioSelection" value="storageLocation" (change)="resetFlagsForStorageLocation($event)"/>
              <label class="custom-control-label " for="storageLocationCheckBox">{{convert('sellModule.posting.locationForm.textSelectStorage')}}</label>
            </div>
            @if (locationForm.value.radioSelection === 'storageLocation') {
              <div class="row container mt-2 ms-1">
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="select-wrapper">
                      <select formControlName="storageLocation" id="storageLocation" class="custom-select wrapText" aria-label="selectStorageLocation" (change)="changeAddress()">
                        @for (storageLocation of storageLocations; track storageLocation) {
                          <option [ngValue]="storageLocation.name">{{storageLocation.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          @if (showIntransitDate()) {
            <div class="row container mt-2 ms-1">
              <div class="custom-control-inline">
                <div class="form-group date-label mb-0 ms-4">
                  <label class="transit-label" for="inTransitArrivalDate">{{convert('sellModule.posting.locationForm.textIntransitArrivalDate')}}</label>
                </div>
              </div>
              <div class="row container">
                <div class="col-md-6">
                  <div class="form-group d-flex date-input" [style.margin]="!inTransitDateValid ? '0%' : ''">
                    <input
                      allytm-click-tagged="true"
                      type="text"
                      class="form-control"
                      #fromDp="ngbDatepicker"
                      ngbDatepicker
                      (dateSelect)="trackFormChanges()"
                      #dpFromDate container="body"
                      aria-label="From Date"
                      [placeholder]="dateFormatter.placeholderText()"
                      maxlength="10"
                      minlength="10"
                      formControlName="inTransitArrivalDate"
                      name="inTransitArrivalDate"
                      id="inTransitArrivalDate"
                      (ngModelChange)="changeDate($event)"
                      [class.is-invalid]="!inTransitDateValid"
                      />
                    <button allytm-click-tagged="true" #fromCalendar class="btn btn-outline-primary calendar-button"
                      (click)="fromDp.toggle()" [attr.aria-label]="convert('sellModule.posting.locationForm.textIntransitArrivalDate')" [style.border-color]="!inTransitDateValid ? 'red' : ''">
                      <i class="allycon-calendar" aria-hidden="true" ></i>
                    </button>
                  </div>
                  <div class="error-message" aria-atomic="true" aria-live="polite" role="alert">
                    @if (!inTransitDateValid) {
                      <div><strong>{{convert('sellModule.posting.locationForm.textInTransitArrivalDateValidationError')}}</strong></div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="control-wrapper mt-3">
            <div class="custom-control custom-radio custom-control-inline ">
              <input type="radio" id="locationNumberCheckBox" name="radioSelection" class="custom-control-input"
                formControlName="radioSelection" value="locationNumber" (change)="resetFlagsForLocationNumber($event)"/>
              <label class="custom-control-label " for="locationNumberCheckBox">{{convert('sellModule.posting.locationForm.textEnterLocation')}}</label>
            </div>

            @if (isLocationNumberSelected()) {
              <div class="row container mt-2 ms-1 locationNumber">
                <div class="col-md-6">
                  <div class="form-group">
                    <input formControlName="locationNumber" class="form-control" id="locationNumberTextBox" type="text"
                      name="locationNumber" [class.is-invalid]="locationRetrievalFailed" (ngModelChange)="onLocationChange($event)"/>
                    @if (locationRetrievalFailed) {
                      <span class="invalid-feedback" id="error">
                        {{convert('sellModule.posting.locationForm.textLocationNumber')}}
                      </span>
                    }
                  </div>
                </div>
                <div class="retrievebutton">
                  <button class="btn btn-outline-primary" type="button" aria-label="Retrieve" data-track-name="Retrieve"
                    data-track-trigger="modal" (click)="retrieveLocationNumberAddress()" >
                    {{convert('sellModule.posting.locationForm.btnRetrieve')}}
                  </button>
                </div>
                @if (showIntransitDateForLocation()) {
                  <div class="row container mt-2 me-2">
                    <div class="custom-control-inline">
                      <div class="form-group date-label mb-0 ms-3">
                        <label for="inTransitArrivalDate">{{convert('sellModule.posting.locationForm.textIntransitArrivalDate')}}</label>
                      </div>
                    </div>
                    <div class="row container">
                      <div class="col-md-6">
                        <div class="form-group d-flex date-input-loc-number" [style.margin]="!inTransitDateValid ? '0%' : ''">
                          <input
                            allytm-click-tagged="true"
                            type="text"
                            class="form-control"
                            #fromDp="ngbDatepicker"
                            ngbDatepicker
                            (dateSelect)="trackFormChanges()"
                            #dpFromDate container="body"
                            aria-label="From Date"
                            [placeholder]="dateFormatter.placeholderText()"
                            maxlength="10"
                            minlength="10"
                            formControlName="inTransitArrivalDate"
                            name="inTransitArrivalDate"
                            id="inTransitArrivalDate"
                            (ngModelChange)="changeDate($event)"
                            [class.is-invalid]="!inTransitDateValid"
                            />
                          <button allytm-click-tagged="true" #fromCalendar class="btn btn-outline-primary calendar-button"
                            (click)="fromDp.toggle()" [attr.aria-label]="convert('sellModule.posting.locationForm.textIntransitArrivalDate')" [style.border-color]="!inTransitDateValid ? 'red' : ''">
                            <i class="allycon-calendar" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="error-message" aria-atomic="true" aria-live="polite" role="alert">
                          @if (!inTransitDateValid) {
                            <div><strong>{{convert('sellModule.posting.locationForm.textInTransitArrivalDateValidationError')}}</strong></div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (postAdhocLocation) {
            <div class="control-wrapper mt-3">
              <div class="custom-control custom-radio custom-control-inline ">
                <input type="radio" id="locationAddressCheckBox" name="radioSelection" class="custom-control-input"
                  formControlName="radioSelection" value="locationAddress" (change)="resetFlagsForLocationAddress($event)"/>
                <label class="custom-control-label " for="locationAddressCheckBox">{{convert('sellModule.posting.locationForm.labelEnterLocationAdd')}}</label>
              </div>
            </div>
          }
        </div>

        <div class="col-md-6 mt-3">
          <div>
            @if (isStorageLocationSelected()) {
              <div class="col-md-6">
                @if (addressSelected) {
                  <strong>{{convert('sellModule.posting.locationForm.textStorageLocation')}}</strong>
                  <div>
                    {{selectedStorageLocation?.name}}
                  </div>
                  <div>{{selectedStorageLocation?.address?.addressLine1}}</div>
                  <div>{{selectedStorageLocation?.address?.addressLine2}}</div>
                  <div>{{selectedStorageLocation?.address?.city}},
                    {{selectedStorageLocation?.address?.state}},
                  {{selectedStorageLocation?.address?.postalCode}}</div>
                  <div>{{selectedStorageLocation?.contact?.phoneAreaCode + '-' + selectedStorageLocation?.contact?.phoneAreaCode
                  | formatPhoneNumber }}</div>
                }
              </div>
            }
          </div>
          <div>
            @if (isLocationNumberSelected()) {
              <div class="col-md-6">
                @if (locationNumberSelected) {
                  <strong>{{convert('sellModule.posting.locationForm.labelLocationNumber')}}</strong>
                  <div>
                    {{locationNumberForm?.name}}
                  </div>
                  <div>{{locationNumberForm?.address?.addressLine1}}</div>
                  <div>{{locationNumberForm?.address?.addressLine2}}</div>
                  <div>{{locationNumberForm?.address?.city}},
                    {{locationNumberForm?.address?.state}},
                  {{locationNumberForm?.address?.postalCode}}</div>
                  <div>{{locationNumberForm?.contact?.phoneAreaCode + '-' + locationNumberForm?.contact?.phoneAreaCode
                  | formatPhoneNumber}}</div>
                }
              </div>
            }
          </div>
          @if (isLocationAddressSelected() && editableAddress) {
            <div class="col-md-6">
              @if (isAddressValidated === false) {
                <div class="text-destructive">
                  {{convert('sellModule.posting.locationForm.textCantFindAdd')}}
                </div>
              }
              @if (errorCount > 0) {
                <div class="text-destructive">
                  {{convert('sellModule.posting.locationForm.textThere')}} {{errorCount === 1 ? convert('sellModule.posting.locationForm.textIs') + errorCount + convert('sellModule.posting.locationForm.textError') : convert('sellModule.posting.locationForm.textAre') + errorCount + convert('sellModule.posting.locationForm.textErrors')}} {{convert('sellModule.posting.locationForm.textSubmitted')}}
                </div>
              }
              <div class="form-group">
                <label for="locationName">{{convert('sellModule.posting.locationForm.labelLocationName')}}</label>
                <input formControlName="locationName" class="form-control" [ngClass]="{ 'invalid-input': !validLocationName }"
                  id="locationNameTextBox" type="text" name="locationName" (change)="trackFormChanges()" />
                @if (!validLocationName) {
                  <span class="text-destructive">{{convert('sellModule.posting.locationForm.textEnterLocationName')}}</span>
                }
              </div>
              <div class="form-group">
                <label for="addressLine1">{{convert('sellModule.posting.locationForm.labelAddLine1')}}</label>
                <input formControlName="addressLine1" class="form-control" [ngClass]="{ 'invalid-input': !validAddress }"
                  id="addressLine1TextBox" type="text" name="addressLine1" (change)="trackFormChanges()" />
                @if (!validAddress) {
                  <span class="text-destructive">{{convert('sellModule.posting.locationForm.textEnterAdd')}}</span>
                }
              </div>
              <div class="form-group">
                <label for="addressLine2">{{convert('sellModule.posting.locationForm.labelAddLine2')}}</label>
                <input formControlName="addressLine2" class="form-control" id="addressLine2TextBox" type="text"
                  name="addressLine2" (change)="trackFormChanges()" />
              </div>
              <div class="form-group">
                <label for="city">{{convert('sellModule.posting.locationForm.labelCity')}}</label>
                <input formControlName="city" class="form-control" [ngClass]="{ 'invalid-input': !validCity }"
                  id="cityTextBox" type="text" name="city" (change)="trackFormChanges()" />
                @if (!validCity) {
                  <span class="text-destructive">{{convert('sellModule.posting.locationForm.textEnterCity')}}</span>
                }
              </div>
              <div class="form-group">
                <label for="state">{{convert('sellModule.posting.locationForm.labelState')}}</label>
                <div class="select-wrapper">
                  <select formControlName="state" id="state" class="custom-select" [ngClass]="{ 'invalid-input': !validState }"
                    (change)="trackFormChanges()">
                    @for (state of stateProvinceList; track state) {
                      <option [ngValue]="state.abbr">{{state.name}}</option>
                    }
                  </select>
                </div>
                @if (!validState) {
                  <span class="text-destructive">{{convert('sellModule.posting.locationForm.textEnterState')}}</span>
                }
              </div>
              <div class="form-group">
                <label for="postalCode">{{convert('sellModule.posting.locationForm.labelPostalCode')}}</label>
                <input formControlName="postalCode" class="form-control" [ngClass]="{ 'invalid-input': !validPostalCode }"
                  id="postalCodeTextBox" type="text" name="postalCode" (change)="trackFormChanges()" />
                @if (!validPostalCode) {
                  <span class="text-destructive"><bold>{{convert('sellModule.posting.locationForm.textEnterPostal')}}</bold></span>
                }
              </div>
              <div class="form-group">
                <label for="contactPhone">{{convert('sellModule.posting.locationForm.labelContactPhone')}}</label>
                <input formControlName="contactPhone" class="form-control" id="contactPhoneTextBox" type="text"
                  name="contactPhone" (change)="trackFormChanges()" />
              </div>
              <button class="btn btn-link ps-0 validate-address-button" [attr.data-track-name]="'Validate Address'"
                [attr.aria-label]="convert('sellModule.posting.locationForm.ariaLabelValidateAddress')"
                (click)="validateFormAndAddress()">
                {{convert('sellModule.posting.locationForm.ariaLabelValidateAddress')}}
              </button>
            </div>
          }

          @if (isLocationAddressSelected() && !editableAddress && !!isAddressValidated) {
            <div class="col-md-6 row validated-address">
              <div>
                <em class="allycon-success-fill text-success"></em>
              </div>
              <div class="col-10 validated-address">
                <strong>{{convert('sellModule.posting.locationForm.textAddressValidate')}}</strong>
                <h3 class="content-card-title">{{convert('sellModule.posting.locationForm.textLocationAdd')}}</h3>
                <div>{{postingData.inventoryItem.storageLocation.address?.addressLine1}}</div>
                <div>{{postingData.inventoryItem.storageLocation.address?.addressLine2}}</div>
                <div>{{postingData.inventoryItem.storageLocation.address?.city}},
                  {{postingData.inventoryItem.storageLocation.address?.state}},
                {{postingData.inventoryItem.storageLocation.address?.postalCode}}</div>
                <div>{{postingData.inventoryItem.storageLocation.contactPhone | formatPhoneNumber}}</div>
                <button class="btn btn-link ps-0" [attr.data-track-name]="'Edit'"
                  [attr.aria-label]="convert('sellModule.posting.locationForm.ariaLabelEdit')" (click)="editFormAddress()">
                  {{convert('sellModule.posting.locationForm.ariaLabelEdit')}}
                </button>
              </div>
              @if (showIntransitDateForLocation()) {
                <div class="row container mt-2 me-2">
                  <div class="custom-control-inline">
                    <div class="form-group date-label mb-0 ms-3">
                      <label for="inTransitArrivalDate">{{convert('sellModule.posting.locationForm.textIntransitArrivalDate')}}</label>
                    </div>
                  </div>
                  <div class="row container">
                    <div class="col-md-6">
                      <div class="form-group d-flex date-input-loc-number">
                        <input
                          allytm-click-tagged="true"
                          type="text" class="form-control"
                          #fromDp="ngbDatepicker"
                          ngbDatepicker
                          (dateSelect)="trackFormChanges()"
                          #dpFromDate container="body"
                          aria-label="From Date"
                          [placeholder]="dateFormatter.placeholderText()"
                          maxlength="10"
                          minlength="10"
                          formControlName="inTransitArrivalDate"
                          name="inTransitArrivalDate"
                          id="inTransitArrivalDate"
                          (ngModelChange)="changeDate($event)"
                          />
                        <button allytm-click-tagged="true" #fromCalendar class="btn btn-outline-primary calendar-button"
                          (click)="fromDp.toggle()" [attr.aria-label]="convert('sellModule.posting.locationForm.textIntransitArrivalDate')">
                          <i class="allycon-calendar" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</ng-container>
